import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Votre partie est terminée.")
const _hoisted_2 = { class: "center" }

import { JourneyData } from '@/model/Journey'
import { Player } from '@/model/Player'
import { PropType } from 'vue'

import GameButton from '@/components/game/basics/GameButton.vue'
import GameTitle from '@/components/game/basics/GameTitle.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GamePlayerTerminated',
  props: {
  player: {
    type: Object as PropType<Player>,
    required: true,
  },
  journey: {
    type: Object as PropType<JourneyData>,
    required: true,
  },
},
  emits: ["logout"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'logout'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(GameTitle, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(GameButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Nav.Logout')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})